import "./skeleton.css";

interface SkeletonRowProps {
    opacity?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
    boxes?: 1 | 2 | 3 | 4;
}

interface SkeletonProps {
    type?: 'grid' | 'rows' | 'table' | 'block' | 'block-grid',
    hasWhiteBackground?: boolean;
}

export const SkeletonTableRow = ({ opacity = 10 }: SkeletonRowProps) => {
    return (
        <div className="skeleton-table-row" style={{ opacity: opacity / 10 }}>
            <div className="skeleton-text-row" />
        </div>
    )
}

export const SkeletonRow = ({ opacity = 10 }: SkeletonRowProps) => {
    return (
        <div className="skeleton-row" style={{ opacity: opacity / 10 }}>
            <div className="skeleton-title" />
            <div className="skeleton-text">
                <div className="skeleton-text-row" />
                <div className="skeleton-text-row" />
            </div>
        </div>
    )
}

const SkeletonGridRow = ({ opacity = 10, boxes = 2 }: SkeletonRowProps) => {
    const skeletonKey = Math.random();
    return (
        <div className="skeleton-grid-row" style={{ opacity: opacity / 10 }}>
            {[...Array(boxes)].map((box, boxIndex) => <div key={`skeleton-box-${skeletonKey}-${boxIndex}`} className="skeleton-box" />)}
        </div>
    )
}

const Skeleton = ({ type = 'rows', hasWhiteBackground = false }: SkeletonProps) => {
    return (
        <div className="skeleton-container">
            <div className={`shiny ${hasWhiteBackground ? 'white-background' : ''}`}/>
            {type === 'rows' ?
                <div className="rows">
                    <SkeletonRow/>
                    <SkeletonRow/>
                    <SkeletonRow opacity={8}/>
                    <SkeletonRow opacity={5}/>
                    <SkeletonRow opacity={2}/>
                </div>
            : null}
            {type === 'grid' ?
                <div className="grid">
                    <SkeletonGridRow boxes={2}/>
                    <SkeletonGridRow boxes={3} opacity={5}/>
                    <SkeletonGridRow boxes={1} opacity={2}/>
                    <SkeletonGridRow boxes={2} opacity={1}/>
                </div>
            : null}
            {type === 'table' ?
                <div className="table">
                    <SkeletonTableRow opacity={8} />
                    <SkeletonTableRow opacity={7} />
                    <SkeletonTableRow opacity={6} />
                    <SkeletonTableRow opacity={5} />
                    <SkeletonTableRow opacity={4} />
                    <SkeletonTableRow opacity={3} />
                    <SkeletonTableRow opacity={2} />
                    <SkeletonTableRow opacity={1} />
                </div>
            : null}

            {type === 'block' ?
                <div className="grid">
                    <SkeletonTableRow boxes={1} opacity={8} />
                </div>
                : null}

            {type === 'block-grid' ?
                <div className="grid">
                    <SkeletonGridRow boxes={3} opacity={8}/>
                </div>
                : null}
        </div>
    );
}

export default Skeleton;